(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart-modal"] && !Shopify.designMode) return;
  try {
    class DialogElement extends HTMLElement {
    connectedCallback() {
      // Ensure modal is hidden by default
      this.style.display = 'none';
      
      // Tab switching
      this.querySelectorAll('.size-chart-modal__tab').forEach(tab => {
        tab.addEventListener('click', () => {
          const targetPanel = tab.dataset.tab;
          
          // Update tabs
          this.querySelectorAll('.size-chart-modal__tab').forEach(t => 
            t.classList.remove('size-chart-modal__tab--active')
          );
          tab.classList.add('size-chart-modal__tab--active');
          
          // Update panels
          this.querySelectorAll('.size-chart-modal__panel').forEach(p => 
            p.classList.remove('size-chart-modal__panel--active')
          );
          this.querySelector(`[data-panel="${targetPanel}"]`).classList.add('size-chart-modal__panel--active');
        });
      });
      
      // Unit toggle (Cm/In)
      this.querySelectorAll('.size-chart-toggle').forEach(toggle => {
        toggle.addEventListener('click', () => {
          const unit = toggle.dataset.unit;
          const table = toggle.dataset.table;
          
          // Update toggle buttons for this table
          this.querySelectorAll(`.size-chart-toggle[data-table="${table}"]`).forEach(btn => 
            btn.classList.remove('size-chart-toggle--active')
          );
          toggle.classList.add('size-chart-toggle--active');
          
          // Show/hide tables for this table group
          this.querySelectorAll(`.size-chart-table__data[data-table="${table}"]`).forEach(tbl => {
            if (tbl.dataset.unit === unit) {
              tbl.style.display = 'table';
            } else {
              tbl.style.display = 'none';
            }
          });
        });
      });
    }
    
    open() {
      this.setAttribute('open', '');
      this.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }
    
    close() {
      this.removeAttribute('open');
      this.style.display = 'none';
      document.body.style.overflow = '';
    }
  }
  
  if (!customElements.get('dialog-element')) {
    customElements.define('dialog-element', DialogElement);
  }
  } catch(e) { console.error(e); }
})();

})();
